import { useMutation } from '@tanstack/react-query';
import { analyticsTrack } from '../../web-analytics/webAnalytics';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import useApi from '../../api/backendApiContext';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import { useNotification } from '../../notification/notificationsContext';
import { AutoChargeDto } from '../dto';

export const useSetAutoChargeMutation = (source: string, onAutoChargeEnabled?: () => void) => {
  const { billingApi } = useApi();
  const queryCacheManager = useQueryCacheManager();
  const { notifySuccess, notifyError } = useNotification();

  return useMutation(async (request: AutoChargeDto) => billingApi.setAutoCharge(request), {
    onMutate: async (request: AutoChargeDto) => {
      await queryCacheManager.updateBillingCustomer({
        autoChargeEnabled: request.enabled,
      });
    },
    onSuccess: async (_response, request) => {
      await queryCacheManager.invalidateBillingCustomer();
      analyticsTrack(
        request.enabled
          ? AnalyticsEvent.AUTOMATIC_PAYMENT_ENABLED
          : AnalyticsEvent.AUTOMATIC_PAYMENT_DISABLED,
        { source }
      );
      const message = `Auto payment settings updated.`;
      notifySuccess({ logMsg: message, notificationMsg: message });
      if (request.enabled && onAutoChargeEnabled) {
        onAutoChargeEnabled();
      }
    },
    onError: async () => {
      await queryCacheManager.invalidateBillingCustomer();
      const message = `Something went wrong while updating auto payment settings.`;
      notifyError({ logMsg: message, notificationMsg: message });
    },
  });
};
